<!-- SIDEBAR HEADER (START)-->
<div class="page-brand">
  <a routerLink="/dashboard">
    <!--span class="brand" style="font-size:16px;"><img src="./assets/img/zero/zero.svg" style="height:24px;"> ZERO BrandCard™</span-->
    <span class="brand" style="font-size:16px;"><img src="./assets/img/zero/logo/zero-brandcard-logo-header.svg" style="width:180px;"></span>
    <span class="brand-mini" style="font-size:12px;"><img src="./assets/img/zero/logo/zero.svg" style="height:24px;"></span>
  </a>
</div>
<!-- SIDEBAR HEADER (END) -->

<div class="dash-header flexbox flex-1">
  <!-- TOP-LEFT TOOLBAR (START)-->
  <ul class="nav navbar-toolbar">
    <li>
      <a class="nav-link sidebar-toggler js-sidebar-toggler" href="javascript:;">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
    </li>
  </ul>
  <!-- TOP-LEFT TOOLBAR (END) -->

  <!-- TOP-RIGHT TOOLBAR (START) -->
  <ul class="nav navbar-toolbar">
    <li class="dropdown dropdown-user">
      <a class="nav-link dropdown-toggle link" data-toggle="dropdown">
        <!--span>{{username}}</span>
        &nbsp;
        <ngx-avatar name="{{username}}" size="40" textSizeRatio="2.5"></ngx-avatar>
        <div class="caret ml-2 mr-2"></div-->
        <img src="./assets/img/zero/dashboard-icon/account-white.svg">
        <img src="./assets/img/zero/dashboard-icon/account-blue.svg" style="display:none;">
      </a>
      <div class="dropdown-menu dropdown-arrow dropdown-menu-right admin-dropdown-menu">
        <!--div class="dropdown-arrow"></div-->
        <div class="dropdown-header">
          <!--div class="admin-avatar">
            <ngx-avatar name="{{username}}" textSizeRatio="2.5"></ngx-avatar>
          </div>
          <div>
            <h5 class="font-strong text-white">{{username}}</h5>
          </div-->
          <div class="username-style"><b>{{username}}</b></div>
        </div>
        <div class="admin-menu-features">
          <a class="admin-features-item" routerLink="/account/profile" (click)="checkAccount()">
            <img src="./assets/img/zero/dashboard-icon/account.svg">
            <span>ACCOUNT</span>
          </a>
          <a class="admin-features-item" routerLink="/account/support" (click)="checkAccount()">
            <i class="ti-support"></i>
            <span>SUPPORT</span>
          </a>
          <!--a class="admin-features-item" href="javascript:;"><i class="ti-settings"></i>
            <span>SETTINGS</span>
          </a-->
        </div>
        <div class="admin-menu-content">
          <div class="d-flex justify-content-end">
            <a class="d-flex align-items-center" (click)="logout()">Logout<i class="ti-shift-right ml-2 font-20"></i></a>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <!-- TOP-RIGHT TOOLBAR (END) -->
</div>
